import { Currency } from '../../../../../../common/types/Currency';

export enum FilterFieldsKeys {
  settlementMonthFrom = 'settlementMonthFrom',
  settlementMonthTo = 'settlementMonthTo',
  distributorAgentId = 'distributorAgentId',
  programName = 'programName',
  currency = 'currency',
}

export interface FilterFields {
  [FilterFieldsKeys.settlementMonthFrom]: string;
  [FilterFieldsKeys.settlementMonthTo]: string;
  [FilterFieldsKeys.distributorAgentId]: string;
  [FilterFieldsKeys.programName]: string;
  [FilterFieldsKeys.currency]: string;
}
